import { render } from "./VonageController.vue?vue&type=template&id=ecf93b84"
import script from "./VonageController.vue?vue&type=script&lang=js"
export * from "./VonageController.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__